import {
  ImageType,
  LanguageCodeObject,
  LanguageModel,
  TranslationItemModel
} from '@/shared/api/BaseAPI.model'

type languagesListResponseModel = {
  en: LanguageModel[]
  pl: LanguageModel[]
}

type languagesListPayloadModel = LanguageCodeObject[]

type accordionItemModel = {
  id?: string
  translations: TranslationItemModel[]
  relatedItems?: TranslationItemModel[]
}

// "HH:mm" both, or null for "served all day". A `to` at or before `from` means
// the window crosses midnight. See SidebarAccordion/config.ts.
type menuTypeHours = {
  activeFrom?: string | null
  activeTo?: string | null
}
/*
  Dish categories served under this menu type. Required by the backend on both
  POST and PUT (`MenuTypeDto.categoryIds`, no `@IsOptional`), and the update
  REPLACES the set rather than merging into it, so an edit has to send back
  everything it was loaded with or the assignments are dropped.
*/
type menuTypeCategories = {
  categoryIds: string[]
}
type menuTypesResponseModel = (accordionItemModel &
  menuTypeHours &
  menuTypeCategories)[]
type menuTypeResponseModel = accordionItemModel &
  menuTypeHours &
  menuTypeCategories
type menuTypePayloadModel = accordionItemModel &
  menuTypeHours &
  menuTypeCategories
type menuTypePutPayloadModel = {
  menuTypeId: string
  menuTypePayload: menuTypePayloadModel
}

type dishSizesResponseModel = accordionItemModel[]
type dishSizeResponseModel = {
  translations: TranslationItemModel[]
}
type dishSizePayloadModel = {
  translations: TranslationItemModel[]
}

type dishSizePutPayloadModel = {
  dishSizeId: string
  dishSizePayload: dishSizePayloadModel
}

type categoryModel = {
  id?: string
  translations: TranslationItemModel[]
  dishSizeIds: string[]
  // Carried by the list response, so the sidebar needs no request per row.
  // Absent for a category with no picture. See SidebarAccordion/config.ts.
  image?: ImageType
}
type categoriesResponseModel = categoryModel[]
type categoryResponseModel = {
  translations: TranslationItemModel[]
  dishSizeIds: string[]
  image?: ImageType
}
type categoryPayloadModel = {
  translations: TranslationItemModel[]
  dishSizesIds: string[]
}
type categoryPutPayloadModel = {
  categoryId: string
  categoryPayload: categoryPayloadModel
}

enum QUERY {
  LANGUAGES = 'LANGUAGES',
  SELECTED_LANGUAGES = 'SELECTED_LANGUAGES',
  SELECTED_DEFAULT_LANGUAGE = 'SELECTED_DEFAULT_LANGUAGE',
  DISH_CATEGORIES = 'CATEGORIES',
  DISH_CATEGORY = 'CATEGORY',
  DISH_CATEGORY_IMAGE = 'CATEGORY_IMAGE',
  MENU_TYPES = 'MENU_TYPES',
  MENU_TYPE = 'MENU_TYPE',
  DISH_SIZES = 'DISH_SIZES',
  DISH_SIZE = 'DISH_SIZE'
}
export { QUERY }
export type {
  languagesListResponseModel,
  languagesListPayloadModel,
  menuTypesResponseModel,
  menuTypeResponseModel,
  menuTypePayloadModel,
  menuTypePutPayloadModel,
  dishSizesResponseModel,
  dishSizeResponseModel,
  dishSizePayloadModel,
  dishSizePutPayloadModel,
  categoryModel,
  categoriesResponseModel,
  categoryResponseModel,
  categoryPayloadModel,
  categoryPutPayloadModel,
  accordionItemModel
}
